<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull"
    @refresh="onRefresh"
  >
    <div class="page">
      <div class="header mb_10 pl_12">
        <div class="avatar-container mr_10">
          <img v-if="accountInfo.avatar" class="avatar" :src="accountInfo.avatar" alt="" />
          <div v-else class="avatar"></div>
        </div>
        <div class="broadcaster-info">
          <div class="broadcaster-title">
            <span>{{ accountInfo.nickname }}</span>
            <div class="ml_6 d_flex" style="flex-wrap: wrap; gap: 4px">
              <div v-for="(t, tIdx) in accountInfo.tagList" :key="tIdx" class="official-tag">
                {{ t }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="game-card mb_8">
        <div class="game-info">
          <img class="game-icon" :src="gameInfo.icon" alt="游戏图标" />
          <div class="game-details">
            <h3 class="game-title van-ellipsis">{{ gameInfo.gameName }}</h3>
          </div>
        </div>
        <div class="view-button fs_14" @click="viewGame">查看游戏</div>
      </div>

      <div class="strategy-item">
        <div class="strategy-title">
          <p class="strategy-title-main color_black bold fs_17">{{ detailInfo.title }}</p>
        </div>
        <div class="strategy-meta">
          <div class="strategy-tags">
            <span class="tag" v-for="(tag, tagIndex) in detailInfo.tagList" :key="tagIndex">#{{ tag }}</span>
          </div>
          <div class="strategy-date">{{ theTime }}</div>
        </div>
      </div>

      <!-- 富文本渲染区域 -->
      <div
        class="strategy-main-v-game-strategy"
        v-html="detailInfo.content"
        @click="handleClickStrategyContent"
      ></div>
      
      <!-- 底部悬浮操作栏 -->
      <div class="bottom-action-bar">
        <div class="view-game-btn fs_15" @click="viewGame">查看游戏</div>
        <div class="action-buttons ml_4">
          <div class="action-button like" @click="toggleLike">
            <van-icon
              class="action-icon"
              :class="{
                'action-icon-acitve': detailInfo.praise
              }"
              size="24"
              :color="detailInfo.praise ? '#F53648' : '#999'"
              :name="detailInfo.praise ? 'like' : 'like-o'"
            />
            <span>{{ wrapCountFn(detailInfo.praiseNum) }}</span>
          </div>
          <div class="action-button favorite" @click="toggleFavorite">
            <van-icon
              class="action-icon"
              :class="{
                'action-icon-acitve': detailInfo.collect
              }"
              size="24"
              :color="detailInfo.collect ? '#f7be65' : '#999'"
              :name="detailInfo.collect ? 'star' : 'star-o'"
            />
            <span>{{ wrapCountFn(detailInfo.collectNum) }}</span>
          </div>
        </div>
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { PullRefresh, Icon } from "vant";
import { setPageTitle, onGoBack, jumpToNative, jumpToNewWeb, getUserInfo, toLogin, onAnalyticsTrackEvent } from "@/bridge/AppJsBridge";
import LinkTo from '@/mixins/linkTo'
import EventTrack from '@/mixins/eventTrack'
import { getGameStrategyDetailApi, likeGameStrategyApi, collectGameStrategyApi } from '@/apis/btBoxActivity'
import { ImagePreview } from 'vant';
import { debounce } from '@wanxin-site/common-utils'
import Common from './common'
import { inithandler } from "@/bridge/jsBridge";
import { getCookie } from "@/libs/utils";

const frameStr = '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0'

export default {
  mixins: [EventTrack, LinkTo, Common],
  components: {
    PullRefresh,
    [Icon.name]: Icon
  },
  data() {
    return {
      isLoading: false,
      disabledPull: false,
      detailInfo: {},
      accountInfo: {},
      skipInit: true,
      gameInfo: {
        icon: '',
        gameName: '',
        gameId: '',
        guideGameId: '',
      },
      strategyList: [
        {
          isHighlight: true,
          title: '【大神攻略】这可能是t1梯度的阵容，金铲铲s13阵容大头蜘蛛',
          tags: ['大神攻略', '必看'],
          updateDate: '25/02/23'
        },
        // 可以添加更多攻略项目
      ],
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.referer_path = from.fullPath
    })
  },
  mounted () {
    // 当前页面是否是一级页面
    if (['', '/', null, undefined].includes(this.referer_path)) {
      inithandler()
    }
    // init 防止从 H5 过来的页面没有初始化
    this.init();
    this.getAppToken()
  },
  computed: {
    guideId () {
      return this.$route.query.guideId
    },
    theTime () {
      const fulltime = this.detailInfo.updateTime || this.detailInfo.createTime || ""
      const time = fulltime.split(" ")[0]
      return time + ' 更新'
    },
  },
  methods: {
    init() {
      // 初始化数据，可以从API获取
      return this.fetchStrategyData()
    },
    onRefresh() {
      this.init().finally(() => {
        setTimeout(() => {
          this.isLoading = false
        }, 200)
      })
    },
    fetchStrategyData(track = true) {
      return getGameStrategyDetailApi({
        guideId: this.guideId
      }, !this.isWx).then(res => {
        // rest = gameId, gameName, icon, guideGameId
        const { detailVo, ...rest  } = res.data || {}
        const { accountVo, ...rest2 } = detailVo || {}
        this.gameInfo = rest
        rest2.content = this.replaceVideoWithImg(rest2.content)
        this.detailInfo = rest2
        this.accountInfo = accountVo || {}

        if (track) {
          setPageTitle(this.gameInfo.gameName + '攻略')
          this.onTrack("guide_page", {
            page_type: 3,
            guide_id: this.detailInfo.guideId,
            guide_name: this.detailInfo.title,
          })
        }
      }).catch(err => {
        const { code, msg } = err
        // 1802 - 攻略配置不存在时返回
        // 1800 - 攻略游戏配置关闭时返回
        // 1801 - 游戏已下架时返回
        const errorCode = [1802, 1800, 1801]
        if (errorCode.includes(code)) {
          setTimeout(() => {
            onGoBack()
          }, 2000)
        }
      })
    },
    viewGame() {
      this.onTrack("guide_view_game_button", {
        page_type: 3,
      })
      this.goGameDetail()
    },
    // 事件代理处理
    handleClickStrategyContent (e) {
      if (!e || !e.target) return
      const { target } = e
      if (target.tagName === 'IMG') {
        const imgSrc = target.getAttribute('src')
        // 如果含有这个标识，我们视为视频
        const isVideo = imgSrc.includes(frameStr)
        if (isVideo) {
          const videoSrc = imgSrc.split(frameStr)[0]
          // this.previewVideo(videoSrc)
        } else {
          this.previewImg(imgSrc)
        }
      }
      // 视频点击热区变成 icon
      if (target.tagName === 'I') {
        const src = target.dataset.vsrc
        // 获取点击元素的兄弟img元素
        const imgElement = target.parentElement.querySelector('img')
        const imgWidth = imgElement?.naturalWidth
        const imgHeight = imgElement?.naturalHeight
        let imgOrientation = 1
        if ((imgWidth && imgHeight)) {
          // 判断图片方向：宽>=高为横版1，宽<高为竖版2
          imgOrientation =  imgWidth >= imgHeight ? 1 : 2
        }
        if (src) {
          this.previewVideo(src, imgOrientation)
        }
      }
      if (target.tagName === 'A') {
        // 获取当前 a 标签的 src 并阻止默认行为
        const src = target.getAttribute('href');
        e.preventDefault();
        try {
          // 获取链接中的路由和参数部分
          const urlObj = new URL(src);
          const { pathname, host } = urlObj
          const hostWhiteList = [
            'wxhdtest.hzwxbz999.cn',
            'wxhdpre.hzwxbz999.cn',
            'wxhd.hzwxbz2.cn',
          ]
          const activityCenterList = [
            'platform-common-h5-test.hzwxbz999.cn',
            'platform-common-h5-pre.hzwxbz999.cn',
            'platform-common-h5.hzwxbz2.cn',
          ]
          // 判断是否的 wxhd 链接是活动还是企微通码
          const pathnameBlackList = [
            '/box/jumpTo',
            '/box/customJumpTo',
            '/box/qiweiGuide',
          ]
          console.log('get the src-->', src)
          // 新容器打开的情况：
          // 1. 活动域名 && /box/ 开头 && 非这些路由
          // 2. 活动中心域名
          // 其他情况用默认浏览器打开
          if (
            (
              hostWhiteList.includes(host) && 
              pathname.startsWith('/box/') &&
              !pathnameBlackList.some(v => pathname.startsWith(v))
            ) ||
            activityCenterList.includes(host)
          ) {
            jumpToNewWeb(src)
          } else {
            this.handleLoadExteral(src)
          }
        } catch (error) {
          console.error(src + ' 是非法链接')
        }
      }
    },
    previewImg (item) {
      ImagePreview({
        images: [item],
        showIndex: false,
      });
    },
    previewVideo: debounce(function (src, orientation) {
      console.log('click video -->', src)
      const data = {
        routePath: "/base/FullscreenVideoActivity",
        extraParams: JSON.stringify({
          url: src,
          orientation
        }),
      }
      jumpToNative(JSON.stringify(data))
    }, 300),
    // 点赞功能
    toggleLike: debounce(async function() {
      try {
        if (!this.validLogin()) return
        await likeGameStrategyApi({
          guideId: this.guideId,
          status: this.detailInfo.praise ? 2 : 1
        }, !this.isWx)
        // 数数上报
        onAnalyticsTrackEvent({
          eventName: 'guide_prase_collect_button',
          guide_id: this.detailInfo.guideId,
          guide_name: this.detailInfo.title,
          game_id: this.gameInfo.gameId,
          game_name: this.gameInfo.gameName,
          opt_type: this.detailInfo.praise ? 2 : 1,
        })
        this.onTrack("guide_prase_collect_button", {
          page_type: 3,
          guide_id: this.detailInfo.guideId,
          guide_name: this.detailInfo.title,
          button_type: 1,
          opt_type: this.detailInfo.praise ? 2 : 1,
        })
        this.fetchStrategyData(false)
      } catch(err) {
        console.error('点赞失败:', err)
      }
    }, 300),
    // 收藏功能  
    toggleFavorite: debounce(async function() {
      try {
        if (!this.validLogin()) return
        await collectGameStrategyApi({
          guideId: this.guideId,
          status: this.detailInfo.collect ? 2 : 1,
        }, !this.isWx)
        // 数数上报
        onAnalyticsTrackEvent({
          eventName: 'guide_prase_collect_button',
          guide_id: this.detailInfo.guideId,
          guide_name: this.detailInfo.title,
          game_id: this.gameInfo.gameId,
          game_name: this.gameInfo.gameName,
          opt_type: this.detailInfo.collect ? 4 : 3,
        })
        this.onTrack("guide_prase_collect_button", {
          page_type: 3,
          guide_id: this.detailInfo.guideId,
          guide_name: this.detailInfo.title,
          button_type: 2,
          opt_type: this.detailInfo.collect ? 2 : 1,
        })
        this.fetchStrategyData(false)
      } catch(err) {
        console.error('收藏失败:', err) 
      }
    }, 300),
    replaceVideoWithImg(richText) {
      // 获取富文本字符中的 video：允许属性任意顺序，并支持跨行匹配
      const videoRegex = /<video\b[^>]*poster="([^"]*)"[^>]*>[\s\S]*?<\/video>/gi;
      const replacedText = richText.replace(videoRegex, (match, poster) => {
        return `<div class="video_preview"><img src="${poster}" alt="视频加载错误"><i size="1rem" data-vsrc="${(poster || '').split(frameStr)[0]}" class="van-icon van-icon-play-circle-o"></i></div>`;
      });
      return replacedText;
    },
    getActivityInfo () {
      this.fetchStrategyData(false);
    },
    validLogin () {
      const token = getCookie("token")
      if (!token) {
        toLogin("/loginKey/LoginByKeyPhoneActivity");
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
.page {
  padding: 8px;
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 70px; // 为底部操作栏留出空间
  color: var(--color-black-1);
}

.header {
  display: flex;
  align-items: center;
  
  .avatar-container {
    
    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px #ccc solid;
    }
  }
  
  .broadcaster-info {
    .broadcaster-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      white-space: nowrap;
      
      .official-tag {
        background-color: #000;
        color: #B38B00;
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 3px;
        white-space: nowrap;
      }
    }
  }
}

.strategy-item {
  background-color: #fff;
  border-radius: 12px;
  padding: 16px 8px;
  margin-bottom: 12px;
  position: relative;

  
  .strategy-tag {
    background-color: #ff4f4f;
    color: white;
    padding: 1px 6px;
    font-size: 10px;
    border-radius: 2px;
    margin-top: -2px;
  }
  
  .strategy-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 12px 0;
    // vertical-align: middle;
    p {
      display: inline-block;
    }
    .strategy-title-main {
      text-indent: 1em;
      line-height: 1.24;
      max-width: 100%;
      white-space: wrap;
      word-break: break-word;
    }
  }
  
  .strategy-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .strategy-tags {
      .tag {
        color: #f09900;
        margin-right: 8px;
        font-size: 14px;
      }
    }
    
    .strategy-date {
      color: #999;
      font-size: 12px;
      white-space: nowrap;
    }
  }
}

// 底部悬浮操作栏样式
.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 50;
  
  .view-game-btn {
    background-color: #ff6347;
    color: white;
    padding: 12px 36px;
    border-radius: 20px;
    flex: 1;
    text-align: center;
  }
  
  .action-buttons {
    display: flex;
    align-items: center;
    
    .action-button {
      display: flex;
      align-items: center;
      
      .action-icon-acitve {
        animation: pulse 0.3s ease;
      }
      i {
        margin-right: 5px;
        font-size: 20px;
        position: relative;
      }
      
      span {
        font-size: 14px;
        color: #666;
        min-width: 48px;
      }
    }

    .action-button.like {
      margin-left: 12px;
    }
    
    .action-button.favorite {
      margin-left: 8px;
    }
  }
}

// 点赞和收藏的动画效果
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>

<style lang="scss">
@import './default.scss';
// 取一个长名字避免和别的样式冲突
.strategy-main-v-game-strategy {
  padding: 2px 4px;
  --margin-side: 8px;
  img, video {
    max-width: 100%
    // max-width: calc(100% - (var(--margin-side) * 2)) !important;
    // margin: 0 var(--margin-side);
  }
  .video_preview {
    position: relative;
    i.van-icon {
      position: absolute;
      left: calc(50% + var(--margin-side));
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 44px;
      color: rgba(255, 255, 255, 0.80);
      z-index: 2;
      // pointer-events: none;
    }
    &::before {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      left: var(--margin-side);
      width: calc(100% - (var(--margin-side) * 2));
      height: calc(100% - 2px);
      background-color: rgba(30, 30, 30, .5);
      pointer-events: none;
    }
  }
}
</style>
